export function validateEmail(email) {
  const re = /\S+@\S+\.\S+/

  const trimmedEmail = email?.trim()
  if (trimmedEmail === '' || !re.test(email)) {
    return false
  }

  return true
}
